/** Normalize label/slug text for demand-claim ↔ topic chip matching (FW-URL-03). */
export function normalizeClaimMatchText(value: string): string {
  return (value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function topicSignalMatchesDemandClaim(
  claimLabel: string | null | undefined,
  signal: { label?: string; topicSlug?: string }
): boolean {
  const claim = normalizeClaimMatchText(claimLabel || '');
  if (!claim) return false;
  const label = normalizeClaimMatchText(signal.label || '');
  const slugPhrase = normalizeClaimMatchText((signal.topicSlug || '').replace(/-/g, ' '));
  if (label && (label === claim || claim.includes(label) || label.includes(claim))) return true;
  if (slugPhrase && (slugPhrase === claim || claim.includes(slugPhrase) || slugPhrase.includes(claim))) {
    return true;
  }
  return false;
}

export function orderTopicSignalsForClaim(
  signals: Array<{ label?: string; topicSlug?: string; weight?: number }>,
  claimLabel: string | null | undefined,
  reorderClaimFirst: boolean
): Array<{ label?: string; topicSlug?: string; weight?: number }> {
  if (!reorderClaimFirst || !claimLabel) return signals;
  const matchIdx = signals.findIndex((signal) => topicSignalMatchesDemandClaim(claimLabel, signal));
  if (matchIdx <= 0) return signals;
  const next = [...signals];
  const [matched] = next.splice(matchIdx, 1);
  next.unshift(matched);
  return next;
}
